<template>
	<div class="subbar" v-if="instance" style="background-color: rgb(247, 245, 249)">
		<div class="searchbar--app">
			<div class="breadcrumbs dF aC">
				<a-breadcrumb class="dF">
					<a-breadcrumb-item>{{ instance.name }}</a-breadcrumb-item>
					<a-breadcrumb-item :class="{ 'subbar-crumb--active': isAppCrumbActive }">{{ selectedAppInitial
					}}</a-breadcrumb-item>
					<a-breadcrumb-item v-for="(crumb, crumbI) in crumbs" :key="crumbI" :class="{
						'subbar-crumb--active':
							crumbI === crumbs.length - 1,
					}">{{ crumb }}</a-breadcrumb-item>
				</a-breadcrumb>
			</div>

			<div v-if="showToolbarActions" class="dF aC ml-auto d-none d-sm-flex">
				<div class="dF aC">
					<a-auto-complete style="width: 300px" placeholder="Search for a home model..."
						:dropdown-match-select-width="false" :dropdown-style="dropdownStyle" option-label-prop="value"
						@search="handleSearch" class="mr-4" size="large">
						<template slot="dataSource">
							<a-select-option @click="optionClicked(model.id)" v-for="model in searchResult"
								:key="model.id" :value="model.name">
								<div class="dF aC">
									<span class="mr-2">
										<img class="subbar-model-thumb" :src="model.image
											? model.image
											: noImageSrc
											" alt="" />
									</span>
									<div class="f1">
										<div>
											<strong>{{ model.name }}</strong>
										</div>
										<small class="text-sm">{{
											model.units.length
										}}
											elevation(s)</small>
									</div>
								</div>
							</a-select-option>
						</template>
						<a-input>
							<a-icon class="subbar-search-icon" slot="prefix" type="search" />
						</a-input>
					</a-auto-complete>

					<div class="mr-4 d-none d-xl-block dash-divider"></div>
					<a-button @click="addModel" type="primary" icon="plus" size="large">
						ADD NEW HOME MODEL
					</a-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';

export default {
	name: 'ModelsSubBar',
	data() {
		return {
			searchResult: [],
			noImageSrc: require('@/assets/no-image.png'),
			dropdownStyle: { width: '300px' },
		};
	},
	computed: {
		...mapState({
			instance: (state) => state.instance,
			crumbs: (state) => state.models.crumbs,
			unitGroups: (state) => state.models.unitGroups,
			displayMode: (state) => state.models.display,
		}),
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || 'HMC';
		},
		isAppCrumbActive() {
			return this.crumbs.length === 0;
		},
		showToolbarActions() {
			const title = this.$route.meta?.title;
			return ['Display Home Models'].includes(title);
		},
	},
	watch: {
		searchResult: {
			handler(val) {
				if (!val.length) return;
				const id = val[0].id;
				if (this.displayMode === 'block') {
					document
						.querySelectorAll('.select-block')
						.forEach((el) => el.classList.remove('select-block'));
					const card = document.querySelector(
						`[card-data-value="${id}"]`,
					);
					if (card) card.classList.add('select-block');
				} else if (this.displayMode === 'list') {
					document
						.querySelectorAll('.select-list')
						.forEach((el) => el.classList.remove('select-list'));
					const row = document.querySelector(
						`[list-data-value="${id}"]`,
					);
					if (row) row.classList.add('select-list');
				}
			},
		},
	},
	methods: {
		handleSearch(input) {
			const q = (input && String(input).trim().toLowerCase()) || '';
			if (q.length < 2) {
				this.searchResult = [];
				return;
			}
			this.searchResult = Object.values(this.unitGroups).filter(
				({ name, type, size }) => {
					const n = (name && String(name).toLowerCase()) || '';
					const t = (type && String(type).toLowerCase()) || '';
					const s = size != null ? String(size) : '';
					return (
						n.includes(q) || t.includes(q) || s.includes(q)
					);
				},
			);
		},
		addModel() {
			this.$router.push('/modeldetails');
			this.$store.commit('SET_CRUMBS', []);
		},
		optionClicked(data) {
			this.$router.push(`/modeldetails/${data}`);
		},
	},
};
</script>
<style lang="scss" scoped>
.ant-breadcrumb>span:last-child,
.subbar-crumb--active {
	color: #f7941e;
}

.subbar-model-thumb {
	width: 30px;
	height: 30px;
	object-fit: cover;
}

.subbar-search-icon {
	stroke: #000;
	stroke-width: 34;
}

@media screen and (min-width: 1030px) {
	.searchbar--app {
		display: flex;
	}
}

@media screen and (max-width: 1030px) {
	.breadcrumbs {
		margin-bottom: 10px;
	}
}
</style>

<style lang="scss">
.ant-card.ant-card-bordered.select-block {
	border: none;
	animation: subbar-highlight-border 2s ease 1;
}

@keyframes subbar-highlight-border {
	100% {
		border: 2px solid var(--orange);
	}
}

.select-list {
	background-color: #fff;
	animation: subbar-highlight-list 2s ease 1;
}

@keyframes subbar-highlight-list {
	100% {
		border: 2px solid var(--orange);
	}
}
</style>
